/** In-app browsers (WeChat etc.) block getUserMedia, so voice calls cannot work there. */
const IN_APP = /MicroMessenger|\bQQ\/|Weibo|Instagram|FBAN|FBAV|\bLine\//u;

export function isInAppBrowser(userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent): boolean {
  return IN_APP.test(userAgent);
}

export const IN_APP_MESSAGE = '微信内置浏览器无法使用麦克风/语音通话。请点右上角 ··· → 在浏览器中打开 (Safari/Chrome)。';

export async function copyLink(url: string = window.location.href): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    const field = document.createElement('textarea');
    field.value = url;
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.append(field);
    field.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    field.remove();
    return ok;
  }
}
